<template>
    <div>
        <van-nav-bar
            title="会员信息"
            left-text="返回"
            left-arrow
            @click-left="clickback"
        />
        <van-cell-group>
            <van-cell title="会员名称" :value="vipinfo.name" is-link @click="update(vipinfo.name, 'name')"/>
            <van-cell title="车辆" :value="vipinfo.carCode" is-link @click="carshow=true"/>
            <van-cell title="会员生日" :value="vipinfo.birthday" @click="dateShowPicker = true" is-link/>
            <van-cell title="会员地址" :value="vipinfo.address" is-link @click="update(vipinfo.address, 'address')"/>
        </van-cell-group>

        <van-popup v-model="dateShowPicker" position="bottom">
            <van-datetime-picker
                type="date"
                v-model="currentDate"
                title="选择年月日"
                @confirm="onDateConfirm"
                @cancel="dateShowPicker = false"
            />
        </van-popup>

        <updatepopup :title='title' :labeltxt='labeltxt' :placeholdertxt='placeholdertxt' ref="updatepopup"/>

        <van-popup
            v-model="carshow"
            closeable
            position="bottom"
            :style="{ height: '50%' }">
            <van-address-list
            v-model="vipinfo.carId"
            :list="carlist"
            default-tag-text="Default"
            add-button-text='增加爱车'
            @select="selCar"
            @add="addCar"
            @edit="editCar"/>
        </van-popup>
        <AddCar ref="addcar" />
    </div>
</template>

<script>
import { NavBar, Cell, CellGroup, Popup, AddressList, Field, Button, DatetimePicker, Dialog } from 'vant';
import { VipInfoApi } from '@/api/vip'
import AddCar from '@/view/user/components/addcar'
import updatepopup from '@/view/user/components/updatepopup'
import moment from 'moment'
import { authURL } from '@/utils/auth'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Popup.name]: Popup,
        [AddressList.name]: AddressList,
        [Field.name]: Field,
        [Button.name]: Button,
        [DatetimePicker.name]: DatetimePicker,
        [Dialog.name]:Dialog,
        AddCar,
        updatepopup
    },
    data() {
        return {
            carshow: false,
            show: false,
            vipinfo: {
                name: null,
                birthday: null,
                address: null,
                carCode: null,
                carId: null
            },
            carlist: [],
            from:{
                name: null,
                birthday: null,
                address: null,
                carId: null
            },
            currentDate: new Date(),
            dateShowPicker: false,

            title: null,
            labeltxt: null,
            placeholdertxt: null,
        }
    },
    mounted(){
        this.getVipInfo()
    },
    methods: {
        onSubmit(){},
        getVipInfo(){
            var that = this
            that.axios.get(VipInfoApi).then((ret) => {
                if (ret.flag) {
                    ret = ret.details
                    that.vipinfo = {
                        name: ret.name?ret.name:'',
                        birthday: ret.birthday?ret.birthday:'',
                        address: ret.address?ret.address:'',
                    }
                    const cars = []
                    ret.cars.forEach((it) => {
                        cars.push({
                        id: it.id,
                        tel: '',
                        name: it.code,
                        address: it.name
                        })
                    })
                    that.carlist = cars
                    // that.carlist = ret.cars
                    ret.cars.forEach(item => {
                        if(item.is_default){
                            that.vipinfo.carCode=item.code
                            that.vipinfo.carId=item.id
                        }
                    });
                } else {
                    if (ret.details) {
                        this.$router.push(authURL(ret.details))
                    } else {
                        Dialog.alert({ title: '警告', message: ret.info })
                    }
                }
            })
        },
        update(vipval, typeval){
            this.title = typeval
            if(typeval==='name'){
                this.from.name = vipval
                this.labeltxt = "会员名称"
                this.placeholdertxt = "请输入会员名称"
            }else if(typeval==='address'){
                this.from.address = vipval
                this.labeltxt = "会员地址"
                this.placeholdertxt = "请输入会员地址"
            }
            this.$refs.updatepopup.showdig(vipval)
        },
        onDateConfirm(date){
            this.from.birthday = moment(date).format('YYYY-MM-DD')
            this.dateShowPicker = false
            this.save()
        },
        save(){
            var that = this
            that.axios.post(VipInfoApi, that.from).then((ret) => {
                console.log(ret)
                if(ret.flag){
                    that.show = false
                    that.getVipInfo()
                }
            }).catch((ex) => {
                console.log(ex)
            })
            that.show = false
        },

        selCar(item) {
            this.from.carId = item.id
            this.carshow = false
            this.save()
        },
        addCar() {
            this.carshow = false
            this.$refs.addcar.add()
        },
        editCar(_, index) {
            console.log('editCar')
            console.log(index)
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/membercentre`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>